<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1">
<h1 style="padding-top:200px">Part 1</h1>
<div class="section level2" id="about-you-biologybiochemistry">
<h2 style="text-align:center">About You (Biology/Biochemistry)</h2>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?398ae3eb